/* global MathJax */
import { loadMathJax } from 'init/mathjax.init'

// Approximates MathJax's own scan (mathjax.init.js) — single-$ spans cross
// newlines, \ref/\eqref count (processRefs). Accepted gap: a scope whose
// only markup is an escaped \$ stays un-typeset.
const RAW_MATH = /\$[^$]+\$|\$\$|\\\(|\\\[|\\begin\{|\\(?:eq)?ref\{/

// Used to hold chain of typesetting calls. Loading and typesetting both
// happen inside the chain so execution order matches call order — otherwise
// concurrent calls race on the load and a later whole-container pass can
// clobber an inner element's already-typeset math (typesetClear orphans the
// output and the source is never re-found).
let promise = Promise.resolve()

export async function typeset(el) {
  promise = promise
    .then(async () => {
      await loadMathJax()

      if (!el?.isConnected) return
      // No un-typeset source left (already typeset, or no math at all) —
      // nothing to do. Critically, a math-less pass must not fall through:
      // typesetPromise rebuilds MathJax's global stylesheet from just this
      // element's characters, clobbering the styling of every formula
      // rendered elsewhere on the page. Edited content still re-typesets
      // because its raw source is back in the DOM.
      if (!RAW_MATH.test(el.textContent)) return

      MathJax.typesetClear([el])

      return MathJax.typesetPromise([el])
    })
    .catch((err) => console.log('Typeset failed: ' + err.message))

  return promise
}
